import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

// import Main from "../pages/client/Intro.vue";
import Main from "../pages/client/Main.vue";

// import { BoardRoutes } from "./board.router";
// import { QuestionRoutes } from "./question.router";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },
    // {
    //     path: "/common/kcp/cert/request",
    //     component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
    //     props: true,
    // },
    // {
    //     path: "/common/kcp/cert/response",
    //     component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
    //     props: true,
    // },
    // {
    //     // 로그인
    //     path: "/login",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
    //     props: true,
    // },
    // {
    //     // 비밀번호 찾기
    //     path: "/login/find-password",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
    //     props: true,
    // },
    // {
    //     // 아이디 찾기
    //     path: "/login/find-id",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입
    //     path: "/join",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/main.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/type",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/type.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/form",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 완료
    //     path: "/join/complete",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
    //     props: true,
    // },
    // {
    //     // 1:1 문의
    //     path: "/mypage/question",
    //     component: () => import(/* webpackChunkName: "question" */ "../pages/client/mypage/question.vue"),
    //     children: [...QuestionRoutes],
    //     props: true,
    // },
    // {
    //     // 회원 정보 상세
    //     path: "/mypage/myinfo",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 정보 변경
    //     path: "/mypage/myinfo/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // Private Sales
    //     path: "/private-sales",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/private-sales/PrivateSalesPage.vue"),
    //     props: true,
    // },
    // {
    //     // Private Sales
    //     path: "/private-sales/:tab",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/private-sales/PrivateSalesPage.vue"),
    //     props: true,
    // },
    // {
    //     // FAQ
    //     path: "/center/faqs",
    //     component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/faq.vue"),
    //     props: true,
    // },
    // {
    //     // 공지사항
    //     path: "/center/notice",
    //     component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
    //     props: true,
    // },
    // {
    //     // 공지사항
    //     path: "/center/notice/:_notification",
    //     component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
    //     props: true,
    // },
    // {
    //     // Forms & Archives
    //     path: "/board/forms",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/Forms.vue"),
    //     children: [...BoardRoutes],
    //     props: true,
    // },
    // {
    //     // 문의 및 제휴
    //     path: "/form/inquiry-partner",
    //     component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/InquiryPartner.vue"),
    //     props: true,
    // },
    {
        // 기업소개
        path: "/about",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/about/AboutPage.vue"),
        props: true,
    },
    {
        // 비즈니스
        path: "/business",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/business/BusinessPage.vue"),
        props: true,
    },
    {
        // 핵심기술
        path: "/technology",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/technology/TechnologyPage.vue"),
        props: true,
    },
    {
        // 솔루션-스마트팜-알엠팜
        path: "/solution/smartfarm/rmfarm",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/solution/SolutionSmartfarmRmfarmPage.vue"),
        props: true,
    },
    {
        // 솔루션-스마트팜-파밍온
        path: "/solution/smartfarm/farmingon",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/solution/SolutionSmartfarmFarmingonPage.vue"),
        props: true,
    },
    {
        // 솔루션-스마트팜-노지스마트팜
        path: "/solution/smartfarm/ground",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/solution/SolutionSmartfarmGroundPage.vue"),
        props: true,
    },
    {
        // 솔루션-스마트팜-스마트관수제어
        path: "/solution/smartfarm/irrigation",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/solution/SolutionSmartfarmIrrigationPage.vue"),
        props: true,
    },
    {
        // 솔루션-팜이레식물공장-LED시스템
        path: "/solution/plant/led",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/solution/SolutionPlantLedPage.vue"),
        props: true,
    },
    {
        // 솔루션-팜이레식물공장-재배대시스템
        path: "/solution/plant/rearing",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/solution/SolutionPlantRearingPage.vue"),
        props: true,
    },
    {
        // 솔루션-팜이레식물공장-식물공장통합관제시스템
        path: "/solution/plant/control",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/solution/SolutionPlantControlPage.vue"),
        props: true,
    },
    {
        // 솔루션-AI빅데이터
        path: "/solution/bigdata",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/solution/SolutionBigdataPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-공지사항
        path: "/community/notice",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/community/CommunityNoticeListPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-공지사항
        path: "/community/notice/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/community/CommunityNoticeViewPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-미디어
        path: "/community/magazine",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/community/CommunityMagazineListPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-미디어
        path: "/community/magazine/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/community/CommunityMagazineViewPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-IR
        path: "/community/ir",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/community/CommunityIrListPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-IR
        path: "/community/ir/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/community/CommunityIrViewPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-문의하기
        path: "/community/inquire",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/sub/community/CommunityInquirePage.vue"),
        props: true,
    },
    {
        // 커뮤니티-제품카탈로그
        path: "/community/catalog",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/community/CommunityCatalogListPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-제품카탈로그
        path: "/community/catalog/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/community/CommunityCatalogViewPage.vue"),
        props: true,
    },
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 영문 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/en",
        component: () => import(/* webpackChunkName: "main" */ "../pages/client/en/Main.vue"),
    },
    {
        // 기업소개
        path: "/en/about",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/about/AboutPage.vue"),
        props: true,
    },
    {
        // 비즈니스
        path: "/en/business",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/business/BusinessPage.vue"),
        props: true,
    },
    {
        // 핵심기술
        path: "/en/technology",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/technology/TechnologyPage.vue"),
        props: true,
    },
    {
        // 솔루션-스마트팜-알엠팜
        path: "/en/solution/smartfarm/rmfarm",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/solution/SolutionSmartfarmRmfarmPage.vue"),
        props: true,
    },
    {
        // 솔루션-스마트팜-파밍온
        path: "/en/solution/smartfarm/farmingon",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/solution/SolutionSmartfarmFarmingonPage.vue"),
        props: true,
    },
    {
        // 솔루션-스마트팜-노지스마트팜
        path: "/en/solution/smartfarm/ground",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/solution/SolutionSmartfarmGroundPage.vue"),
        props: true,
    },
    {
        // 솔루션-스마트팜-스마트관수제어
        path: "/en/solution/smartfarm/irrigation",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/solution/SolutionSmartfarmIrrigationPage.vue"),
        props: true,
    },
    {
        // 솔루션-팜이레식물공장-LED시스템
        path: "/en/solution/plant/led",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/solution/SolutionPlantLedPage.vue"),
        props: true,
    },
    {
        // 솔루션-팜이레식물공장-재배대시스템
        path: "/en/solution/plant/rearing",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/solution/SolutionPlantRearingPage.vue"),
        props: true,
    },
    {
        // 솔루션-팜이레식물공장-식물공장통합관제시스템
        path: "/en/solution/plant/control",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/solution/SolutionPlantControlPage.vue"),
        props: true,
    },
    {
        // 솔루션-AI빅데이터
        path: "/en/solution/bigdata",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/solution/SolutionBigdataPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-공지사항
        path: "/en/community/notice",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/sub/community/CommunityNoticeListPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-공지사항
        path: "/en/community/notice/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/sub/community/CommunityNoticeViewPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-미디어
        path: "/en/community/magazine",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/sub/community/CommunityMagazineListPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-미디어
        path: "/en/community/magazine/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/sub/community/CommunityMagazineViewPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-IR
        path: "/en/community/ir",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/sub/community/CommunityIrListPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-IR
        path: "/en/community/ir/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/sub/community/CommunityIrViewPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-문의하기
        path: "/en/community/inquire",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/en/sub/community/CommunityInquirePage.vue"),
        props: true,
    },
    {
        // 커뮤니티-제품카탈로그
        path: "/en/community/catalog",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/sub/community/CommunityCatalogListPage.vue"),
        props: true,
    },
    {
        // 커뮤니티-제품카탈로그
        path: "/en/community/catalog/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/sub/community/CommunityCatalogViewPage.vue"),
        props: true,
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 메인
        path: "/console/main",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/ireis/MainPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms/:_form",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardList.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/levels",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/LevelList.vue"),
        props: true,
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/withdrawals",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/WithdrawalList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 공지사항
        path: "/console/center/notifications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Notification.vue"),
        props: true,
    },
    {
        // 관리자 - FAQ
        path: "/console/center/faqs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Faq.vue"),
        props: true,
    },
    {
        // 관리자 - 1:1문의
        path: "/console/center/questions",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Question.vue"),
        props: true,
    },

    {
        // 관리자 - 서비스 이용약관
        path: "/console/terms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/terms/TermsList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners/:_banner",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 팝업
        path: "/console/popups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popup/PopupList.vue"),
        props: true,
    },
    {
        // 관리자 - 설정
        path: "/console/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
        props: true,
    },
    {
        // 관리자 - 비밀번호
        path: "/console/password",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/PasswordView.vue"),
        props: true,
    },
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 영문 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 - 폼메일관리
        path: "/console/en/forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/en/forms/:_form",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/en/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardList.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/en/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/en/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,

    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = undefined,
            mobileWidth = 1200,
            headerHeight = 60;
        if (window.innerWidth > mobileWidth) {
            headerHeight = 100;
        }

        if (to.hash) {
            return {
                selector: to.hash,
                offset: { x: 0, y: headerHeight },
                behavior: "smooth",
            };
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }
    },
});

router.beforeEach((to, from, next) => {
    try {
        const accessToken = sessionStorage.getItem("accessToken");
        axios.defaults.headers.common["Authorization"] = !!accessToken ? `Bearer ${accessToken}` : "";
        axios.defaults.headers.common["Accept-Language"] = i18n.locale;

        const route = routes.find((route) => route.path == to.path);
        if (!route?.scope) next();
        else {
            if (!accessToken) {
                if (0 <= to.path.indexOf("console")) {
                    next();
                    return;
                } else throw new Error("로그인 후 이용가능합니다");
            }

            const payload = JSON.parse(atob(accessToken.split(".")[1]));
            const scope = payload?.scope || [];

            if (!scope.find((scope) => route.scope.includes(scope))) {
                throw new Error("접근권한이 없습니다");
            }

            next();
        }
    } catch (error) {
        alert(error.message);
        window.location.href = routes.find((route) => route.path == from.path)?.path ?? routes.find((route) => route.path == "/")?.path ?? "about:blank";
    }
});

export default router;
